exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".homeOwnerSpinner{position:fixed;left:0px;top:0px;width:100%;height:100%;z-index:9999;background:url(\"\") 50% 50% no-repeat #f9f9f9}@keyframes lds-ring{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/HomeOwnerSpinner/loaderHO.scss
// module id = 1599
// module chunks = 33